<template>
    <v-card fluid>
        <v-card-title>
            <v-row cols="12" dense>
                <v-col cols="1"><btn_component data="" type="text" icon="mdi-keyboard-backspace" text="Back" tooltip="Back to list" size="small" @actionClick="viewAll" v-if="(answer_copy===question.oavr_antwoord_def&&reason_copy===question.oavr_reject_oms)||oavr_nr===-1"/></v-col>
                <v-col cols="11"><h2>{{ this.title }}</h2></v-col>
            </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row cols="12" dense>
                <v-col cols="1">Source</v-col>
                <v-col cols="9">{{ question.oavr_bron }}</v-col>
                <v-col cols="1"><btn_component data="" type="text" text="Choose prompt" tooltip="Choose an existing prompt" size="small" @actionClick="choosePrompt" v-if="oavr_nr===-1"/></v-col>
                <v-col cols="1"></v-col>           
            </v-row>
            <v-row cols="12" dense>
                <v-col cols="1"><br>Category</v-col>
                <v-col cols="2"><v-select v-model="question.oact_code" :items="categories" item-value="Option" item-text="Description" label="Category"></v-select></v-col>
                <v-col cols="1"></v-col>
                <v-col cols="1"><br>Language</v-col>
                <v-col cols="2"><v-select v-model="question.taal_code" :items="languages" item-value="Option" item-text="Description" label="Languages"></v-select></v-col>
            </v-row>
            <v-row cols="12" dense>
                <v-col cols="1">Question</v-col>
                <v-col cols="10"><v-textarea v-model="question.oavr_vraag" variant="outlined" :readonly="question.oavr_bron!=='user'" outlined></v-textarea></v-col>
            </v-row>
            <v-row cols="12" dense v-if="question.oavr_bron!=='user'">
                <v-col cols="1">To</v-col>
                <v-col cols="11">{{ question.oavr_antw_zend_methode }}</v-col>
            </v-row>
            <v-row cols="12" dense v-if="question.oavr_nr!==-1">
                <v-col cols="1"><br>Rating</v-col>
                <v-col cols="2"><v-select v-model="question.oavr_rating" :items="ratings" item-value="Option" item-text="Description" label="Rating" @change="saveRating"></v-select></v-col>
                <v-col cols="1" ></v-col>
                <v-col cols="1" v-if="question.oavr_rating==='Rejected'"><br>Reason</v-col>
                <v-col cols="3" class="pt-6" v-if="question.oavr_rating==='Rejected'"><v-text-field v-model="question.oavr_reject_oms" label="Reason of rejection" dense></v-text-field></v-col>
            </v-row>
            <v-row cols="12" dense v-if="question.oavr_nr!==-1">
                <v-col cols="1">Answer</v-col>
                <v-col cols="10"><v-textarea v-model="question.oavr_antwoord_def" :rows=6 variant="outlined" outlined></v-textarea></v-col>
                <v-col cols="1">
                    <btn_component data="" type="text" icon="mdi-content-copy" text="Copy" tooltip="copy answer to clipboard" size="small" @actionClick="copyAnswer"/>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-row cols="12" class="pt-0 pb-2" dense>
                <v-col cols="1">
                </v-col>
                <v-spacer></v-spacer>
                <btn_component class="px-2" data="" type="text" text="Submit" tooltip="Submit question to chatGPT" size="small" @actionClick="submitQuestion" v-if="question.oavr_nr===-1"/>
                <btn_component class="px-2" data="" type="text" text="Undo changes" tooltip="Undo current changes" size="small" @actionClick="undoChanges" v-if="answer_copy!==question.oavr_antwoord_def"/>
                <btn_component class="px-2" data="" type="text" text="Save reason" tooltip="Update the reason" size="small" @actionClick="saveReason" v-if="reason_copy!==question.oavr_reject_oms"/>
                <btn_component class="px-2" data="" type="text" text="Save changes" tooltip="Update the answer" size="small" @actionClick="saveAnswer" v-if="answer_copy!==question.oavr_antwoord_def"/>
                <v-col cols="1">
                </v-col>
            </v-row>
        </v-card-actions>
        <prompt_selector ref="prompt_selector"/>
    </v-card>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import prompt_selector from "@/components/task/customer_success/openai/prompt_selector.vue";
    export default {
        components: {
            btn_component,
            prompt_selector,
        },    
        props: {
            oavr_nr: {
                type: Number,
                required: true,
            }
        },
        data() {
            return {
                title: "User question details",
                question: {
                    oavr_reject_oms: "",
                    oavr_antwoord_def: ""
                },
                answer_copy: "",
                reason_copy: "",
                categories: [],
                languages: [],
                ratings: [],
            }
        },    
        mounted() {
            this.getQuestionDetails();
        },
        methods: {     
            setTitle() {
                if (this.oavr_nr === -1) {
                    this.title = "New user question";
                } else {
                    this.title = "User question details";
                }
            },
            getQuestionDetails() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/getQuestionDetails.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getQuestionDetails"
                    },
                    getQuestionDetails: {
                        oavr_nr: this.oavr_nr,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                        this.viewAll();
                    } else {
                        this.question = res.data.getQuestionDetails;
                        this.categories = res.data.oact;
                        this.ratings = res.data.rating_codes;
                        this.languages = res.data.language_codes;
                        this.answer_copy = this.question.oavr_antwoord_def;
                        this.reason_copy = this.question.oavr_reject_oms;
                        this.setTitle();
                    }
                });
            },
            viewAll() {
                this.$emit("updateView", 0);
            },
            choosePrompt() {
                this.$refs.prompt_selector.openDialog(this.question);
            },
            copyAnswer() {
                navigator.clipboard.writeText(this.question.oavr_antwoord_def);
                this.$store.dispatch("setSnackbar", {
                    showing: true,
                    text: "Answer copied to clipboard.",
                    color: "success"
                });
            },
            saveAnswer() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/saveQuestionAnswer.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveQuestionAnswer"
                    },
                    saveQuestionAnswer: {
                        oavr_encrid: this.question.oavr_encrid,
                        oavr_antwoord_def: this.question.oavr_antwoord_def,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveQuestionAnswer.text,
                            color: res.data.saveQuestionAnswer.color
                        });
                        this.answer_copy = this.question.oavr_antwoord_def;
                    }
                });
            },
            saveReason() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/saveRejectReason.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveRejectReason"
                    },
                    saveRejectReason: {
                        oavr_encrid: this.question.oavr_encrid,
                        oavr_reject_oms: this.question.oavr_reject_oms,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveRejectReason.text,
                            color: res.data.saveRejectReason.color
                        });
                        this.reason_copy = this.question.oavr_reject_oms;
                    }
                });
            },
            undoChanges() {
                this.question.oavr_antwoord_def = this.answer_copy;
                this.question.oavr_reject_oms = this.reason_copy;
            },
            submitQuestion() {
                // Checks
                if (this.question.oact_code==="") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "You must choose a category first",
                        color: "error"
                    }); 
                    return;                   
                } 
                if (this.question.taal_code==="") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "You must choose a language first",
                        color: "error"
                    }); 
                    return;                   
                } 
                if (this.question.oavr_vraag==="") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "There is no question text !!",
                        color: "error"
                    }); 
                    return;                   
                } 
                this.$axios.post("ares/json/ares/task/customer_success/openai/submitQuestion.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "submitQuestion"
                    },
                    submitQuestion: {
                        oavr_encrid: this.question.oavr_encrid,
                        question: this.question,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.submitQuestion.text,
                            color: res.data.submitQuestion.color
                        });
                        this.$emit("updateView", res.data.submitQuestion.oavr_nr);
                        this.oavr_nr = res.data.submitQuestion.oavr_nr;
                        this.getQuestionDetails();
                    }
                });
            },
            saveCategory() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/saveQuestionCategory.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveQuestionCategory"
                    },
                    saveQuestionCategory: {
                        oavr_encrid: this.question.oavr_encrid,
                        oact_code: this.question.oact_code,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveQuestionCategory.text,
                            color: res.data.saveQuestionCategory.color
                        });
                        this.question.oact_oms = res.data.saveQuestionCategory.oms
                    }
                });
            },
            saveRating() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/saveQuestionRating.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveQuestionRating"
                    },
                    saveQuestionRating: {
                        oavr_encrid: this.question.oavr_encrid,
                        oavr_rating: this.question.oavr_rating,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveQuestionRating.text,
                            color: res.data.saveQuestionRating.color
                        });
                        this.question.oavr_rating_oms = res.data.saveQuestionRating.oms
                        this.question.oavr_status = res.data.saveQuestionRating.status;
                    }
                });
            },

        }
    }
</script>

<style scoped> 

</style>